<template>
    <div class="clearfix rounded mt-4 pb-5 mx-auto px-0 ">
        <div class="mt-4 employee-tab leave-attendance-dashboard document-tab  bg-white">
            <div class="employee-tab leave-attendance-dashboard  bg-white ibox">
                <b-tabs pills content-class="" nav-class=" pr-2 m-2" nav-wrapper-class="col-md-9 card no-shadow custom-margin custom-tab-nav custom-tab-nav-employee ibox ml-auto pl-0 bg-white">
                    <b-tab lazy active>
                        <template v-slot:title>
                            <i class="fa fa-folder-open"></i> HR Policies & Handbook
                        </template>
                        <div class="tab-item-wrapper">
                            <hr-policy-handbook-by-department  :flg="0"></hr-policy-handbook-by-department>
                        </div>
                    </b-tab>
                    <b-tab lazy >
                        <template v-slot:title>
                            <i class="fa fa-folder-open"></i> Personal Documents
                        </template>
                        <div class="tab-item-wrapper">
                            <personal-documents  :flg="1"></personal-documents>
                        </div>
                    </b-tab>
                    <b-tab lazy >
                        <template v-slot:title>
                            <i class="fa fa-folder-open"></i>Tax Documents
                        </template>
                        <div class="tab-item-wrapper">
                            <tax-documents  :flg="1"></tax-documents>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template v-slot:title>
                            <i class="fa fa-folder-open"></i>Employment Documents
                        </template>
                        <div class="tab-item-wrapper">
                            <employment-documents  :flg="1"></employment-documents>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template v-slot:title>
                            <i class="fa fa-folder-open"></i>Personal Tax Return Filing Acknowledgement
                        </template>
                        <div class="tab-item-wrapper">
                            <personal-tax-return-filing-ack  :flg="1"></personal-tax-return-filing-ack>
                        </div>
                    </b-tab>
                    <b-tab lazy >
                        <template v-slot:title>
                            <i class="fa fa-folder-open"></i>Other Documents
                        </template>
                        <div class="tab-item-wrapper">
                            <other-documents  :flg="1"></other-documents>
                        </div>
                    </b-tab>

                    <!-- Added by Afrin start here -->
                    <b-tab lazy>
                        <template v-slot:title>
                            <i class="fa fa-folder-open"></i>NOC Documents
                        </template>
                        <b-card-text><employee-noc-documents :pageurl="$api_url"
                                :flg="1"></employee-noc-documents></b-card-text>
                    </b-tab>
                    <!-- Added by Afrin end here -->
                </b-tabs>
            </div>
        </div>

    </div>
</template>
<script>

    export default{

        mounted() {

        },
        data(){

            return {

            }
        },
        methods:{
        },
        created: function(){

        }
    }


</script>


